export class Credentials{
	constructor(
		public username: string,
		public password: string
	){

	}
}
export class AuthToken{
	customerId: string;
	customerName: string;
	ip: String;
	referer: String;
	account: String;
	authType: Object;
	authenticated: boolean;
	authorities: Array<Object>[];
	credentials: string;
	details: Object;
	name: String;
	principal: string;
}

export class Locale{
	constructor(
		private name: string,
		public language: string
	){

	}
	public equals(obj: Locale) : boolean{
		if(obj.language == this.language){
			return true;
		}
		return false;
	}

	public getName() : string {
		return this.name;
	}

	public getLanguage(): string{
		return this.language;
	}
}

export class Album{
//	public empty: boolean;
	constructor(
		public albumId: string,
		private albumName: string,
		public empty: boolean
	){};
	public isEmpty(): boolean{
		return this.empty;
	}
}
export class Photo{
	public albumId:string;
	id: number;
	location: string;
	title: string;
	width: number;
	height: number;
	page : string;
	description : string;
	vol: string;
	color: string;
	engTitle: string;
	engDescription : string;

//	 public setWidth(width: Number){
//		 this.desciption.trim().length
// *ngIf="x.desciption.trim().length > 0" 
// *ngIf="x.description !== null && x.desciption.length > 0"
//									x.description.trim().length
	// 	this.width = null;
//	 }
}
export class Header{
	public referer: string;
}
export class Buyer{
	public paper: Paper;
	private destination: Destination;
//	public shipping: Shipping;
	constructor(
		public name: string,
		public mail: string,
		public amount: number
	){

	}
	public setDestination(dest: Destination): void{
		this.destination = dest;
	}
	public getDestination(): Destination{
		return this.destination;
	}
}
export class Paper{
	constructor(
		public type: number,
		public name: string,
		public price: number
	){};
}
export class Destination{
	private selectedShippingProfile: ShippingProfile;
	constructor(
		public id: number,
		public name: string,
		public shippingProfiles: Array<ShippingProfile>
		// public shippingPrices: Array<number>,
		// public shippingPeriods: Array<String>

	){};
	public getSelectedShippingProfile(): ShippingProfile{
		return this.selectedShippingProfile;
	}
}
export class ShippingProfile{
	constructor(
		public shipping: Shipping,
		private price: number,
		private period: string

	){}
	public getPrice() : number{
		return this.price;
	}
}
export class Shipping{
	constructor(
		public id: number,
		public name: string
	){};
}
export class MailContent{
	constructor(
		private receiver: string,
		private subject: string,
		private body: string
	){};
}



// WEBPACK FOOTER //
// ./src/app/bean.ts